import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../api";
import { ADMIN_LOGIN_PATH } from "./Adminpaths";

const SUBCATEGORY_OPTIONS = [
  "Cases & Covers",
  "Screen Protectors",
  "Chargers & Cables",
  "Earphones & Audio",
  "Power Banks",
  "Repair Service",
  "General",
];

const emptyForm = {
  subcategory: "General",
  name: "",
  description: "",
  price: "",
  mrp: "",
  stock: "",
  unit: "1 pc",
  image: null,
};

const emptyPinForm = {
  pincode: "",
  area_name: "",
  active: 1,
};

const getEnglishName = (name) => {
  if (!name) return "";
  if (typeof name === "string") {
    try {
      const parsed = JSON.parse(name);
      return parsed.en || Object.values(parsed)[0] || "";
    } catch {
      return name; 
    }
  }
  if (typeof name === "object") return name.en || Object.values(name)[0] || "";
  return "";
};

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` },
});

const imageSrc = (image) => {
  if (!image) return null;
  return image.startsWith("http") ? image : `${API_URL}/${image}`;
};

/* ---------------------------------------------------------------------- */
/* Styles — plain CSS, scoped with an "aia-" prefix                       */
/* ---------------------------------------------------------------------- */

const styles = `
.aia-app { display: flex; height: 100vh; background: #f8fafc; font-family: -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; color: #0f172a; }

/* Sidebar */
.aia-sidebar { width: 240px; flex-shrink: 0; background: #0f172a; color: #e2e8f0; display: flex; flex-direction: column; }
.aia-sidebar__brand { padding: 20px; font-size: 20px; font-weight: 700; letter-spacing: -0.01em; border-bottom: 1px solid rgba(255,255,255,0.08); }
.aia-sidebar__nav { flex: 1; display: flex; flex-direction: column; padding: 12px 8px; gap: 4px; }
.aia-sidebar__tab { width: 100%; display: flex; align-items: center; padding: 12px 16px; border-radius: 6px; font-size: 13.5px; font-weight: 600; color: #94a3b8; background: transparent; border: none; cursor: pointer; text-align: left; transition: all 0.2s ease; }
.aia-sidebar__tab:hover { background: rgba(255,255,255,0.05); color: #e2e8f0; }
.aia-sidebar__tab--active { background: rgba(59, 130, 246, 0.15); color: #60a5fa; font-weight: 700; }
.aia-sidebar__footer { padding: 12px; border-top: 1px solid rgba(255,255,255,0.08); }
.aia-sidebar__logout { display: flex; align-items: center; gap: 8px; width: 100%; padding: 10px 14px; border-radius: 6px; font-size: 14px; color: #fca5a5; background: transparent; border: none; cursor: pointer; text-align: left; }
.aia-sidebar__logout:hover { background: rgba(248,113,113,0.12); }

/* Main column */
.aia-main { flex: 1; display: flex; flex-direction: column; overflow: hidden; }
.aia-header { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 16px; padding: 20px 32px; background: #fff; border-bottom: 1px solid #e2e8f0; }
.aia-header h1 { margin: 0; font-size: 19px; font-weight: 700; }
.aia-header p { margin: 4px 0 0; font-size: 13px; color: #64748b; }
.aia-header__stats { display: flex; align-items: center; gap: 14px; padding-right: 14px; border-right: 1px solid #e2e8f0; font-size: 13px; color: #64748b; }
.aia-header__stats strong { color: #0f172a; }
.aia-header__alert { display: inline-flex; align-items: center; gap: 5px; color: #dc2626; font-weight: 600; }
.aia-header__right { display: flex; align-items: center; gap: 14px; }
.aia-content { flex: 1; overflow-y: auto; padding: 24px 32px 48px; }

.aia-btn { border: none; border-radius: 6px; padding: 9px 14px; font-size: 13px; font-weight: 700; cursor: pointer; }
.aia-btn--primary { background: #2874f0; color: #fff; }
.aia-btn--primary:hover { background: #1e5fce; }
.aia-btn--primary:disabled { background: #cbd5e1; cursor: not-allowed; }
.aia-btn--ghost { background: transparent; color: #64748b; }
.aia-btn--ghost:hover { background: #f1f5f9; }

/* Filter bar */
.aia-filters { display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 20px; }
.aia-search { position: relative; flex: 1; min-width: 200px; max-width: 320px; }
.aia-search input { width: 100%; padding: 8px 10px 8px 30px; border-radius: 6px; border: 1px solid #cbd5e1; font-size: 13px; box-sizing: border-box; }
.aia-search input:focus { outline: none; border-color: #2874f0; }
.aia-search__icon { position: absolute; left: 9px; top: 50%; transform: translateY(-50%); color: #94a3b8; font-size: 13px; }
.aia-select-filter { padding: 8px 10px; border-radius: 6px; border: 1px solid #cbd5e1; font-size: 13px; color: #475569; background: #fff; }
.aia-select-filter:focus { outline: none; border-color: #2874f0; }

/* Add panels */
.aia-panel { background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 10px; padding: 20px; margin-bottom: 24px; }
.aia-panel__head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; }
.aia-panel__title { margin: 0; font-size: 15px; font-weight: 700; }
.aia-panel__close { border: none; background: transparent; color: #64748b; cursor: pointer; font-size: 16px; line-height: 1; padding: 4px; border-radius: 4px; }
.aia-panel__close:hover { background: rgba(255,255,255,0.7); color: #0f172a; }
.aia-panel__grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 12px; }
.aia-panel__grid--full { grid-column: 1 / -1; }
.aia-panel__actions { grid-column: 1 / -1; display: flex; justify-content: flex-end; gap: 8px; margin-top: 4px; }
.aia-upload { display: flex; align-items: center; gap: 8px; border: 1.5px dashed #93c5fd; border-radius: 6px; padding: 9px 10px; font-size: 13px; color: #475569; background: #fff; cursor: pointer; }
.aia-upload:hover { border-color: #2874f0; color: #2874f0; }
.aia-upload input { display: none; }

/* Fields */
.aia-field-label { font-size: 11.5px; color: #64748b; font-weight: 500; display: flex; flex-direction: column; gap: 3px; }
.aia-input, .aia-select, .aia-textarea { width: 100%; padding: 7px 9px; border-radius: 6px; border: 1px solid #cbd5e1; font-size: 13px; box-sizing: border-box; font-family: inherit; background: #fff; }
.aia-input:focus, .aia-select:focus, .aia-textarea:focus { outline: none; border-color: #2874f0; }
.aia-input:disabled, .aia-select:disabled, .aia-textarea:disabled { background: #f8fafc; color: #94a3b8; }
.aia-textarea { resize: vertical; }

/* Empty state */
.aia-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; text-align: center; border: 1.5px dashed #cbd5e1; border-radius: 10px; padding: 60px 20px; color: #94a3b8; }
.aia-empty strong { color: #475569; font-size: 14px; }
.aia-empty span { font-size: 12.5px; }

/* Product grid + card */
.aia-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(230px, 1fr)); gap: 18px; }
.aia-card { display: flex; flex-direction: column; background: #fff; border: 1px solid #e2e8f0; border-radius: 10px; overflow: hidden; }
.aia-card__image-wrap { position: relative; width: 100%; aspect-ratio: 4 / 3; background: #f1f5f9; }
.aia-card__image { width: 100%; height: 100%; object-fit: cover; display: block; }
.aia-card__image-empty { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; font-size: 12px; color: #94a3b8; }
.aia-card__badge { position: absolute; top: 8px; left: 8px; display: inline-flex; align-items: center; gap: 4px; background: #fff; border: 1px solid #fecaca; color: #dc2626; font-size: 10.5px; font-weight: 700; padding: 3px 8px; border-radius: 999px; }
.aia-card__badge-dot { width: 6px; height: 6px; border-radius: 50%; background: #dc2626; }
.aia-card__photo-btn { position: absolute; bottom: 8px; right: 8px; display: inline-flex; align-items: center; gap: 5px; background: rgba(15,23,42,0.7); color: #fff; font-size: 11px; font-weight: 600; padding: 5px 10px; border-radius: 999px; cursor: pointer; }
.aia-card__photo-btn:hover { background: rgba(15,23,42,0.88); }
.aia-card__photo-btn input { display: none; }
.aia-card__body { display: flex; flex-direction: column; gap: 10px; padding: 14px; flex: 1; }
.aia-card__name { border: none; border-bottom: 1px solid transparent; background: transparent; font-size: 14.5px; font-weight: 700; padding: 0 0 3px; font-family: inherit; }
.aia-card__name:focus { outline: none; border-bottom-color: #2874f0; }
.aia-card__sub { width: fit-content; border-radius: 999px; border: 1px solid #e2e8f0; background: #f8fafc; color: #475569; font-size: 11.5px; padding: 4px 10px; font-family: inherit; }
.aia-card__sub:focus { outline: none; border-color: #2874f0; }
.aia-card__desc { font-size: 12px; }
.aia-card__field-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
.aia-card__discount { margin: -4px 0 0; font-size: 11.5px; color: #94a3b8; }
.aia-card__discount del { margin-right: 5px; }
.aia-card__discount b { color: #0c831f; font-weight: 700; }
.aia-card__actions { margin-top: auto; display: flex; align-items: center; justify-content: space-between; gap: 8px; padding-top: 4px; }
.aia-card__delete { display: inline-flex; align-items: center; gap: 5px; background: transparent; border: none; color: #94a3b8; font-size: 12px; font-weight: 600; padding: 6px 8px; border-radius: 6px; cursor: pointer; }
.aia-card__delete:hover { background: #fef2f2; color: #dc2626; }
.aia-card__delete:disabled { opacity: 0.5; cursor: not-allowed; }
.aia-card__save { border: none; border-radius: 6px; padding: 7px 14px; font-size: 12px; font-weight: 700; cursor: pointer; background: #f1f5f9; color: #94a3b8; }
.aia-card__save--dirty { background: #2874f0; color: #fff; cursor: pointer; }
.aia-card__save--dirty:hover { background: #1e5fce; }
.aia-card__save:disabled { cursor: not-allowed; }

/* Table for Serviceable Pincodes */
.aia-table-wrap { background: #fff; border: 1px solid #e2e8f0; border-radius: 10px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.04); }
.aia-table { width: 100%; border-collapse: collapse; text-align: left; font-size: 13.5px; }
.aia-table th { background: #f8fafc; padding: 14px 18px; font-weight: 700; color: #475569; border-bottom: 1px solid #e2e8f0; }
.aia-table td { padding: 14px 18px; border-bottom: 1px solid #f1f5f9; vertical-align: middle; }
.aia-table tr:last-child td { border-bottom: none; }
.aia-table tr:hover td { background: #fafafa; }
.aia-pill { display: inline-block; padding: 4px 10px; border-radius: 999px; font-size: 12px; font-weight: 700; }
.aia-pill--active { background: #dcfce7; color: #166534; }
.aia-pill--inactive { background: #fee2e2; color: #991b1b; }
.aia-pill--pin { background: #eff6ff; color: #1d4ed8; font-family: monospace; font-size: 13px; }

/* Responsive adjustments */
@media (max-width: 900px) {
  .aia-sidebar { width: 190px; }
  .aia-header__stats { display: none; }
}

@media (max-width: 640px) {
  .aia-app { flex-direction: column; height: auto; min-height: 100vh; }
  .aia-sidebar { width: 100%; flex-direction: row; align-items: center; }
  .aia-sidebar__brand { padding: 14px 16px; border-bottom: none; font-size: 16px; white-space: nowrap; }
  .aia-sidebar__nav { flex-direction: row; padding: 8px 12px; }
  .aia-sidebar__footer { border-top: none; padding: 10px 12px 10px 0; }
  .aia-sidebar__logout { width: auto; padding: 8px 12px; }

  .aia-header { padding: 14px 16px; }
  .aia-header__right { width: 100%; justify-content: space-between; }
  .aia-header__stats { display: flex; border-right: none; padding-right: 0; }
  .aia-content { padding: 14px 16px 32px; }

  .aia-filters { flex-direction: column; }
  .aia-search { max-width: none; }

  .aia-panel { padding: 16px; }
  .aia-panel__grid { grid-template-columns: 1fr; }

  .aia-grid { grid-template-columns: 1fr; gap: 14px; }
  .aia-card__field-grid { grid-template-columns: 1fr 1fr; }

  .aia-btn { padding: 10px 14px; }
  .aia-table-wrap { overflow-x: auto; }
}
`;

function Field({ label, children }) {
  return (
    <label className="aia-field-label">
      {label}
      {children}
    </label>
  );
}

function AccessoryEditCard({ item, onSave, onDelete }) {
  const buildDraft = (src) => ({
    subcategory: src.subcategory || "General",
    name: getEnglishName(src.name),
    description: src.description || "",
    price: src.price ?? "",
    mrp: src.mrp ?? "",
    stock: src.stock ?? "",
    unit: src.unit || "1 pc",
  });

  const [form, setForm] = useState(() => buildDraft(item));
  const [dirty, setDirty] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!dirty) setForm(buildDraft(item));
  }, [item.name, item.subcategory, item.description, item.price, item.mrp, item.stock, item.unit, dirty]);

  const change = (field, value) => {
    setForm((f) => ({ ...f, [field]: value }));
    setDirty(true);
  };

  const runSave = async (opts = {}) => {
    if (form.name.trim() === "") return alert("Product name can't be empty.");
    if (form.price === "") return alert("Price can't be empty.");

    const priceNum = Number(form.price);
    if (Number.isNaN(priceNum) || priceNum < 0) return alert("Enter a valid price.");

    if (form.stock !== "") {
      const stockNum = Number(form.stock);
      if (Number.isNaN(stockNum) || stockNum < 0) return alert("Enter a valid stock quantity.");
    }

    setSaving(true);
    try {
      await onSave(item.id, form, opts.imageFile);
      setDirty(false);
    } catch (err) {
      // keep draft
    } finally {
      setSaving(false);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    e.target.value = "";
    if (!file) return;
    runSave({ imageFile: file });
  };

  const outOfStock = Number(item.stock) <= 0;
  const showDiscount = form.mrp !== "" && Number(form.mrp) > Number(form.price || 0);

  return (
    <div className="aia-card">
      <div className="aia-card__image-wrap">
        {item.image ? (
          <img
            src={imageSrc(item.image)}
            alt={getEnglishName(item.name)}
            className="aia-card__image"
            onError={(e) => { e.target.style.display = "none"; }}
          />
        ) : (
          <div className="aia-card__image-empty">No image</div>
        )}

        {outOfStock && (
          <span className="aia-card__badge">
            <span className="aia-card__badge-dot" />
            Out of stock
          </span>
        )}

        <label className="aia-card__photo-btn">
          Change photo
          <input type="file" accept="image/*" disabled={saving} onChange={handleImageChange} />
        </label>
      </div>

      <div className="aia-card__body">
        <input
          className="aia-card__name"
          value={form.name}
          placeholder="Product name"
          disabled={saving}
          onChange={(e) => change("name", e.target.value)}
        />

        <select className="aia-card__sub" value={form.subcategory} disabled={saving} onChange={(e) => change("subcategory", e.target.value)}>
          {SUBCATEGORY_OPTIONS.map((sub) => (<option key={sub} value={sub}>{sub}</option>))}
        </select>

        <textarea
          className="aia-textarea aia-card__desc"
          placeholder="Description"
          value={form.description}
          disabled={saving}
          onChange={(e) => change("description", e.target.value)}
          rows={2}
        />

        <div className="aia-card__field-grid">
          <Field label="Unit">
            <input className="aia-input" type="text" placeholder="1 pc" value={form.unit} disabled={saving} onChange={(e) => change("unit", e.target.value)} />
          </Field>
          <Field label="Stock">
            <input className="aia-input" type="number" min="0" value={form.stock} disabled={saving} onChange={(e) => change("stock", e.target.value)} />
          </Field>
          <Field label="Price (₹)">
            <input className="aia-input" type="number" min="0" step="0.01" value={form.price} disabled={saving} onChange={(e) => change("price", e.target.value)} />
          </Field>
          <Field label="MRP (₹)">
            <input className="aia-input" type="number" min="0" step="0.01" value={form.mrp} disabled={saving} onChange={(e) => change("mrp", e.target.value)} />
          </Field>
        </div>

        {showDiscount && (
          <p className="aia-card__discount">
            <del>₹{form.mrp}</del>
            <b>{Math.round((1 - Number(form.price) / Number(form.mrp)) * 100)}% off</b>
          </p>
        )}

        <div className="aia-card__actions">
          <button className="aia-card__delete" onClick={() => onDelete(item.id)} disabled={saving}>
            Delete
          </button>
          <button
            className={`aia-card__save ${dirty ? "aia-card__save--dirty" : ""}`}
            onClick={() => runSave()}
            disabled={saving || !dirty}
          >
            {saving ? "Saving…" : dirty ? "Save changes" : "Saved"}
          </button>
        </div>
      </div>
    </div>
  );
}

function AddProductPanel({ form, onChange, onSubmit, adding, onClose }) {
  return (
    <div className="aia-panel">
      <div className="aia-panel__head">
        <h2 className="aia-panel__title">Add a new product</h2>
        <button className="aia-panel__close" onClick={onClose}>✕</button>
      </div>

      <form onSubmit={onSubmit} className="aia-panel__grid">
        <Field label="Product name">
          <input className="aia-input" placeholder="e.g. USB-C braided cable" value={form.name} onChange={(e) => onChange("name", e.target.value)} />
        </Field>

        <Field label="Subcategory">
          <select className="aia-select" value={form.subcategory} onChange={(e) => onChange("subcategory", e.target.value)}>
            {SUBCATEGORY_OPTIONS.map((sub) => (<option key={sub} value={sub}>{sub}</option>))}
          </select>
        </Field>

        <Field label="Unit">
          <input className="aia-input" type="text" placeholder="1 pc" value={form.unit} onChange={(e) => onChange("unit", e.target.value)} />
        </Field>

        <Field label="Stock">
          <input className="aia-input" type="number" min="0" placeholder="10" value={form.stock} onChange={(e) => onChange("stock", e.target.value)} />
        </Field>

        <Field label="Price (₹)">
          <input className="aia-input" type="number" min="0" step="0.01" value={form.price} onChange={(e) => onChange("price", e.target.value)} />
        </Field>

        <Field label="MRP (₹, optional)">
          <input className="aia-input" type="number" min="0" step="0.01" value={form.mrp} onChange={(e) => onChange("mrp", e.target.value)} />
        </Field>

        <div className="aia-panel__grid--full">
          <Field label="Description">
            <textarea className="aia-textarea" placeholder="Short description" value={form.description} onChange={(e) => onChange("description", e.target.value)} rows={1} />
          </Field>
        </div>

        <div className="aia-panel__grid--full">
          <Field label="Product photo">
            <label className="aia-upload">
              {form.image ? form.image.name : "Choose an image"}
              <input type="file" accept="image/*" onChange={(e) => onChange("image", e.target.files[0])} />
            </label>
          </Field>
        </div>

        <div className="aia-panel__actions">
          <button type="button" className="aia-btn aia-btn--ghost" onClick={onClose}>Cancel</button>
          <button type="submit" className="aia-btn aia-btn--primary" disabled={adding}>
            {adding ? "Adding…" : "Add product"}
          </button>
        </div>
      </form>
    </div>
  );
}

// Add Pincode Panel
function AddPincodePanel({ form, onChange, onSubmit, adding, onClose }) {
  return (
    <div className="aia-panel">
      <div className="aia-panel__head">
        <h2 className="aia-panel__title">Add Serviceable Location</h2>
        <button className="aia-panel__close" onClick={onClose}>✕</button>
      </div>

      <form onSubmit={onSubmit} className="aia-panel__grid">
        <Field label="6-Digit Pincode">
          <input 
            className="aia-input" 
            placeholder="e.g. 500001" 
            maxLength={6}
            value={form.pincode} 
            onChange={(e) => onChange("pincode", e.target.value)} 
          />
        </Field>

        <Field label="Area Name">
          <input 
            className="aia-input" 
            placeholder="e.g. Test Area, Hyderabad" 
            value={form.area_name} 
            onChange={(e) => onChange("area_name", e.target.value)} 
          />
        </Field>

        <Field label="Status">
          <select 
            className="aia-select" 
            value={form.active} 
            onChange={(e) => onChange("active", Number(e.target.value))}
          >
            <option value={1}>Active (Deliverable)</option>
            <option value={0}>Inactive (Disabled)</option>
          </select>
        </Field>

        <div className="aia-panel__actions">
          <button type="button" className="aia-btn aia-btn--ghost" onClick={onClose}>Cancel</button>
          <button type="submit" className="aia-btn aia-btn--primary" disabled={adding}>
            {adding ? "Adding…" : "Add Location"}
          </button>
        </div>
      </form>
    </div>
  );
}

/* ---------------------------------------------------------------------- */
/* Main Admin Component                                                   */
/* ---------------------------------------------------------------------- */

export default function AdminMobileAccessories() {
  const navigate = useNavigate();

  // Tab State: 'products' | 'pincodes'
  const [activeTab, setActiveTab] = useState("products");

  // Products State
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newForm, setNewForm] = useState({ ...emptyForm });
  const [adding, setAdding] = useState(false);
  const [showAddPanel, setShowAddPanel] = useState(false);
  const [search, setSearch] = useState("");
  const [subFilter, setSubFilter] = useState("All");

  // Pincodes State
  const [pincodes, setPincodes] = useState([]);
  const [pinLoading, setPinLoading] = useState(false);
  const [showAddPinPanel, setShowAddPinPanel] = useState(false);
  const [newPinForm, setNewPinForm] = useState({ ...emptyPinForm });
  const [addingPin, setAddingPin] = useState(false);
  const [editingPinCode, setEditingPinCode] = useState(null);
  const [editAreaName, setEditAreaName] = useState("");
  const [editActive, setEditActive] = useState(1);
  const [pinSearch, setPinSearch] = useState("");

  useEffect(() => { 
    loadItems(); 
    loadPincodes();
  }, []);

  // --- Products Handlers ---
  const loadItems = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/admin/mobile-accessories`, authHeaders());
      setItems(Array.isArray(res.data?.items) ? res.data.items : []);
    } catch (err) {
      if (err.response?.status === 401) {
        alert("Your admin session has expired. Please log in again.");
        localStorage.removeItem("adminToken");
        navigate(ADMIN_LOGIN_PATH);
        return;
      }
      alert(err.response?.data?.message || "Failed to load mobile accessories");
    } finally {
      setLoading(false);
    }
  };

  const saveItem = async (id, form, imageFile) => {
    const payload = new FormData();
    payload.append("subcategory", form.subcategory);
    payload.append("name", form.name.trim());
    payload.append("description", form.description || "");
    payload.append("price", form.price);
    payload.append("mrp", form.mrp || "");
    payload.append("stock", form.stock === "" ? "0" : form.stock);
    payload.append("unit", form.unit || "1 pc");
    if (imageFile) payload.append("image", imageFile);

    try {
      await axios.put(`${API_URL}/admin/mobile-accessories/${id}`, payload, authHeaders());
      await loadItems();
    } catch (err) {
      alert(err.response?.data?.message || "Update failed");
      throw err;
    }
  };

  const deleteItem = async (id) => {
    if (!window.confirm("Are you sure you want to delete this product?")) return;
    try {
      await axios.delete(`${API_URL}/admin/mobile-accessories/${id}`, authHeaders());
      loadItems();
    } catch (err) {
      alert(err.response?.data?.message || "Failed to delete product");
    }
  };

  const handleNewFormChange = (field, value) => {
    setNewForm((prev) => ({ ...prev, [field]: value }));
  };

  const submitNewItem = async (e) => {
    e.preventDefault();
    if (!newForm.name.trim() || newForm.price === "" || !newForm.image) {
      return alert("Name, price, and image are all required");
    }

    const payload = new FormData();
    payload.append("subcategory", newForm.subcategory);
    payload.append("name", newForm.name.trim());
    payload.append("description", newForm.description || "");
    payload.append("price", newForm.price);
    payload.append("mrp", newForm.mrp || "");
    payload.append("stock", newForm.stock === "" ? "10" : newForm.stock);
    payload.append("unit", newForm.unit || "1 pc");
    payload.append("image", newForm.image);

    setAdding(true);
    try {
      await axios.post(`${API_URL}/admin/mobile-accessories`, payload, authHeaders());
      setNewForm({ ...emptyForm });
      setShowAddPanel(false);
      loadItems();
    } catch (err) {
      alert(err.response?.data?.message || "Failed to add product");
    } finally {
      setAdding(false);
    }
  };

  // --- Pincodes Handlers ---
  const loadPincodes = async () => {
    setPinLoading(true);
    try {
      const res = await axios.get(`${API_URL}/admin/mobile-accessories/pincodes`, authHeaders());
      setPincodes(Array.isArray(res.data?.pincodes) ? res.data.pincodes : []);
    } catch (err) {
      console.error("Failed to load pincodes:", err);
    } finally {
      setPinLoading(false);
    }
  };

  const handleNewPinChange = (field, value) => {
    setNewPinForm((prev) => ({ ...prev, [field]: value }));
  };

  const submitNewPincode = async (e) => {
    e.preventDefault();
    if (!newPinForm.pincode.trim() || !newPinForm.area_name.trim()) {
      return alert("Both Pincode and Area Name are required.");
    }
    if (newPinForm.pincode.trim().length !== 6 || isNaN(Number(newPinForm.pincode))) {
      return alert("Please enter a valid 6-digit pincode.");
    }

    setAddingPin(true);
    try {
      await axios.post(`${API_URL}/admin/mobile-accessories/pincodes`, newPinForm, authHeaders());
      setNewPinForm({ ...emptyPinForm });
      setShowAddPinPanel(false);
      loadPincodes();
    } catch (err) {
      alert(err.response?.data?.message || "Failed to add pincode");
    } finally {
      setAddingPin(false);
    }
  };

  const startEditPin = (pin) => {
    setEditingPinCode(pin.pincode);
    setEditAreaName(pin.area_name);
    setEditActive(pin.active !== undefined ? pin.active : 1);
  };

  const cancelEditPin = () => {
    setEditingPinCode(null);
    setEditAreaName("");
    setEditActive(1);
  };

  const saveEditPin = async (pincode) => {
    if (!editAreaName.trim()) return alert("Area name cannot be empty.");

    try {
      await axios.put(
        `${API_URL}/admin/mobile-accessories/pincodes/${pincode}`,
        { area_name: editAreaName.trim(), active: editActive },
        authHeaders()
      );
      setEditingPinCode(null);
      loadPincodes();
    } catch (err) {
      alert(err.response?.data?.message || "Failed to update location");
    }
  };

  const togglePinStatus = async (pin) => {
    const newStatus = pin.active === 1 ? 0 : 1;
    try {
      await axios.put(
        `${API_URL}/admin/mobile-accessories/pincodes/${pin.pincode}`,
        { area_name: pin.area_name, active: newStatus },
        authHeaders()
      );
      loadPincodes();
    } catch (err) {
      alert(err.response?.data?.message || "Failed to update status");
    }
  };

  const deletePincode = async (pincode) => {
    if (!window.confirm(`Are you sure you want to remove pincode ${pincode}?`)) return;
    try {
      await axios.delete(`${API_URL}/admin/mobile-accessories/pincodes/${pincode}`, authHeaders());
      loadPincodes();
    } catch (err) {
      alert(err.response?.data?.message || "Failed to delete pincode");
    }
  };

  const logout = () => {
    localStorage.removeItem("adminToken");
    navigate(ADMIN_LOGIN_PATH);
  };

  const outOfStockCount = useMemo(() => items.filter((i) => Number(i.stock) <= 0).length, [items]);

  const filteredItems = useMemo(() => {
    const q = search.trim().toLowerCase();
    return items.filter((item) => {
      const matchesSub = subFilter === "All" || item.subcategory === subFilter;
      const matchesSearch = !q || getEnglishName(item.name).toLowerCase().includes(q);
      return matchesSub && matchesSearch;
    });
  }, [items, search, subFilter]);

  const filteredPincodes = useMemo(() => {
    const q = pinSearch.trim().toLowerCase();
    return pincodes.filter((p) => {
      return !q || String(p.pincode).includes(q) || (p.area_name && p.area_name.toLowerCase().includes(q));
    });
  }, [pincodes, pinSearch]);

  return (
    <div className="aia-app">
      <style>{styles}</style>

      {/* Sidebar with Navigation Tabs */}
      <div className="aia-sidebar">
        <div className="aia-sidebar__brand">Admin Panel</div>
        <nav className="aia-sidebar__nav">
          <button 
            className={`aia-sidebar__tab ${activeTab === "products" ? "aia-sidebar__tab--active" : ""}`}
            onClick={() => setActiveTab("products")}
          >
            📦 Products
          </button>
          <button 
            className={`aia-sidebar__tab ${activeTab === "pincodes" ? "aia-sidebar__tab--active" : ""}`}
            onClick={() => setActiveTab("pincodes")}
          >
            📍 Serviceable Locations
          </button>
        </nav>
        <div className="aia-sidebar__footer">
          <button className="aia-sidebar__logout" onClick={logout}>Logout</button>
        </div>
      </div>

      {/* Main content */}
      <div className="aia-main">
        {/* PRODUCTS VIEW */}
        {activeTab === "products" && (
          <>
            <header className="aia-header">
              <div>
                <h1>Mobile accessories</h1>
                <p>Manage products, pricing and stock</p>
              </div>

              <div className="aia-header__right">
                <div className="aia-header__stats">
                  <span><strong>{items.length}</strong> products</span>
                  {outOfStockCount > 0 && (
                    <span className="aia-header__alert">⚠ {outOfStockCount} out of stock</span>
                  )}
                </div>
                <button className="aia-btn aia-btn--primary" onClick={() => setShowAddPanel((v) => !v)}>
                  + Add product
                </button>
              </div>
            </header>

            <div className="aia-content">
              {showAddPanel && (
                <AddProductPanel
                  form={newForm}
                  onChange={handleNewFormChange}
                  onSubmit={submitNewItem}
                  adding={adding}
                  onClose={() => setShowAddPanel(false)}
                />
              )}

              <div className="aia-filters">
                <div className="aia-search">
                  <span className="aia-search__icon">⌕</span>
                  <input type="text" placeholder="Search products" value={search} onChange={(e) => setSearch(e.target.value)} />
                </div>
                <select className="aia-select-filter" value={subFilter} onChange={(e) => setSubFilter(e.target.value)}>
                  <option value="All">All subcategories</option>
                  {SUBCATEGORY_OPTIONS.map((sub) => (<option key={sub} value={sub}>{sub}</option>))}
                </select>
              </div>

              {loading ? (
                <p style={{ color: "#64748b", fontSize: "13px" }}>Loading products…</p>
              ) : filteredItems.length === 0 ? (
                <div className="aia-empty">
                  <strong>{items.length === 0 ? "No products yet" : "No products match your filters"}</strong>
                  <span>{items.length === 0 ? "Add your first product to get started." : "Try a different search or subcategory."}</span>
                </div>
              ) : (
                <div className="aia-grid">
                  {filteredItems.map((item) => (
                    <AccessoryEditCard key={item.id} item={item} onSave={saveItem} onDelete={deleteItem} />
                  ))}
                </div>
              )}
            </div>
          </>
        )}

        {/* PINCODES VIEW */}
        {activeTab === "pincodes" && (
          <>
            <header className="aia-header">
              <div>
                <h1>Serviceable Locations</h1>
                <p>Manage deliverable pincodes and operational zones for Mobile Accessories</p>
              </div>

              <div className="aia-header__right">
                <div className="aia-header__stats">
                  <span><strong>{pincodes.length}</strong> total areas</span>
                  <span><strong>{pincodes.filter(p => p.active === 1).length}</strong> active</span>
                </div>
                <button className="aia-btn aia-btn--primary" onClick={() => setShowAddPinPanel((v) => !v)}>
                  + Add location
                </button>
              </div>
            </header>

            <div className="aia-content">
              {showAddPinPanel && (
                <AddPincodePanel
                  form={newPinForm}
                  onChange={handleNewPinChange}
                  onSubmit={submitNewPincode}
                  adding={addingPin}
                  onClose={() => setShowAddPinPanel(false)}
                />
              )}

              <div className="aia-filters">
                <div className="aia-search">
                  <span className="aia-search__icon">⌕</span>
                  <input 
                    type="text" 
                    placeholder="Search by pincode or area name" 
                    value={pinSearch} 
                    onChange={(e) => setPinSearch(e.target.value)} 
                  />
                </div>
              </div>

              {pinLoading ? (
                <p style={{ color: "#64748b", fontSize: "13px" }}>Loading locations…</p>
              ) : filteredPincodes.length === 0 ? (
                <div className="aia-empty">
                  <strong>{pincodes.length === 0 ? "No serviceable locations configured" : "No locations match your search"}</strong>
                  <span>{pincodes.length === 0 ? "Add your first deliverable pincode above." : "Try searching another name or pincode."}</span>
                </div>
              ) : (
                <div className="aia-table-wrap">
                  <table className="aia-table">
                    <thead>
                      <tr>
                        <th>Pincode</th>
                        <th>Area Name</th>
                        <th>Status</th>
                        <th style={{ textAlign: "right" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredPincodes.map((pin) => {
                        const isEditing = editingPinCode === pin.pincode;

                        return (
                          <tr key={pin.pincode}>
                            <td>
                              <span className="aia-pill aia-pill--pin">{pin.pincode}</span>
                            </td>

                            <td>
                              {isEditing ? (
                                <input
                                  className="aia-input"
                                  value={editAreaName}
                                  onChange={(e) => setEditAreaName(e.target.value)}
                                  placeholder="Area name"
                                  style={{ maxWidth: "260px" }}
                                />
                              ) : (
                                <strong>{pin.area_name}</strong>
                              )}
                            </td>

                            <td>
                              {isEditing ? (
                                <select
                                  className="aia-select"
                                  value={editActive}
                                  onChange={(e) => setEditActive(Number(e.target.value))}
                                  style={{ width: "auto" }}
                                >
                                  <option value={1}>Active</option>
                                  <option value={0}>Inactive</option>
                                </select>
                              ) : (
                                <button 
                                  onClick={() => togglePinStatus(pin)}
                                  style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
                                  title="Click to toggle status"
                                >
                                  <span className={`aia-pill ${pin.active === 1 ? "aia-pill--active" : "aia-pill--inactive"}`}>
                                    {pin.active === 1 ? "● Active" : "○ Inactive"}
                                  </span>
                                </button>
                              )}
                            </td>

                            <td style={{ textAlign: "right" }}>
                              {isEditing ? (
                                <div style={{ display: "inline-flex", gap: "6px" }}>
                                  <button 
                                    className="aia-btn aia-btn--primary" 
                                    style={{ padding: "5px 10px", fontSize: "12px" }}
                                    onClick={() => saveEditPin(pin.pincode)}
                                  >
                                    Save
                                  </button>
                                  <button 
                                    className="aia-btn aia-btn--ghost" 
                                    style={{ padding: "5px 10px", fontSize: "12px" }}
                                    onClick={cancelEditPin}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              ) : (
                                <div style={{ display: "inline-flex", gap: "8px" }}>
                                  <button 
                                    className="aia-btn aia-btn--ghost" 
                                    style={{ padding: "5px 10px", fontSize: "12px", border: "1px solid #cbd5e1" }}
                                    onClick={() => startEditPin(pin)}
                                  >
                                    Edit
                                  </button>
                                  <button 
                                    className="aia-card__delete" 
                                    onClick={() => deletePincode(pin.pincode)}
                                  >
                                    Delete
                                  </button>
                                </div>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}